<p-dialog
    header="Configure Variant"
    [visible]="visibleSignal()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '44rem' }"
    [breakpoints]="{ '1280px': '95vw' }"
    appendTo="body"
    [modal]="true"
    [closable]="!saving()"
    [draggable]="false"
>
    @if (templateSignal(); as t) {
        <div class="flex flex-col gap-4" (keydown.control.enter)="save()" (keydown.meta.enter)="save()">
            <div class="flex flex-col gap-2 p-3 border border-surface-200 dark:border-surface-700 rounded">
                <div class="flex gap-3 items-start">
                    @if (t.DisplayInfo.ImageUrl) {
                        <img [src]="resolveGameContentUrl(t.DisplayInfo.ImageUrl)" [alt]="t.DisplayInfo.Name" class="w-16 h-16 rounded object-cover flex-shrink-0" />
                    } @else {
                        <div class="w-16 h-16 rounded bg-surface-100 dark:bg-surface-800 flex items-center justify-center flex-shrink-0">
                            <i class="pi pi-image text-muted-color"></i>
                        </div>
                    }
                    <div class="flex flex-col gap-2 flex-1 min-w-0">
                        <div class="flex items-center gap-2 flex-wrap">
                            <div class="font-semibold">{{ previewName(t) }}</div>
                            @if (draft().overrideDisplayInfo) {
                                <p-tag value="Overridden" severity="info" />
                            }
                            @if (!t.IsActive) {
                                <p-tag value="Template inactive" severity="warn" />
                            }
                        </div>
                        @if (previewDescription(t); as desc) {
                            <div class="text-sm text-muted-color whitespace-pre-line break-words">{{ desc }}</div>
                        }
                        <div class="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1 text-xs mt-1">
                            <div class="flex flex-col gap-0.5">
                                <span class="text-muted-color uppercase tracking-wide">Type</span>
                                <span class="font-medium">{{ modeConfigTypeLabel(t.ModeConfig) }}</span>
                            </div>
                            <div class="flex flex-col gap-0.5">
                                <span class="text-muted-color uppercase tracking-wide">Players</span>
                                <span class="font-medium inline-flex items-center gap-1">
                                    <i class="pi pi-users text-xs"></i>
                                    {{ variantPlayerCount(t.ModeConfig) ?? '—' }}
                                </span>
                            </div>
                            <div class="flex flex-col gap-0.5">
                                <span class="text-muted-color uppercase tracking-wide">Entry Fee</span>
                                <span class="font-medium">
                                    @switch (variantEntryFee(t.ModeConfig).kind) {
                                        @case ('fixed') {
                                            <app-funds-display [funds]="$any(variantEntryFee(t.ModeConfig)).funds" />
                                        }
                                        @case ('range') {
                                            {{ $any(variantEntryFee(t.ModeConfig)).min }}–{{ $any(variantEntryFee(t.ModeConfig)).max }}
                                            <span class="text-muted-color">({{ $any(variantEntryFee(t.ModeConfig)).currency }})</span>
                                        }
                                        @default { — }
                                    }
                                </span>
                            </div>
                            <div class="flex flex-col gap-0.5">
                                <span class="text-muted-color uppercase tracking-wide">Reward (1st)</span>
                                <span class="font-medium inline-flex items-center gap-1">
                                    @if (variantTopReward(t.ModeConfig); as r) {
                                        <i class="pi pi-trophy text-xs"></i>
                                        <app-funds-display [funds]="r" />
                                    } @else {
                                        —
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                @if (t.Notes) {
                    <div class="text-xs text-muted-color border-t border-surface-200 dark:border-surface-700 pt-2 mt-1">
                        <span class="font-medium">Notes:</span> {{ t.Notes }}
                    </div>
                }
            </div>

            <div class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700">
                <div class="flex items-center gap-2">
                    <p-checkbox
                        inputId="cfg-ovr-display"
                        [binary]="true"
                        [ngModel]="draft().overrideDisplayInfo"
                        (ngModelChange)="setField('overrideDisplayInfo', $event)"
                    />
                    <label for="cfg-ovr-display" class="font-medium">Override display info</label>
                </div>
                @if (draft().overrideDisplayInfo) {
                    <div class="flex flex-col gap-3 pl-6">
                        <div class="flex flex-col gap-1">
                            <label class="text-sm font-medium">Name <span class="text-red-500">*</span></label>
                            <input
                                pInputText
                                [ngModel]="draft().displayName"
                                (ngModelChange)="setField('displayName', $event ?? '')"
                            />
                        </div>
                        <div class="flex flex-col gap-1">
                            <label class="text-sm font-medium">Description</label>
                            <textarea
                                pTextarea
                                rows="2"
                                [ngModel]="draft().displayDescription"
                                (ngModelChange)="setField('displayDescription', $event ?? '')"
                            ></textarea>
                        </div>
                    </div>
                }
            </div>

            <div class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700">
                <div class="flex items-center gap-2">
                    <p-checkbox
                        inputId="cfg-ovr-active"
                        [binary]="true"
                        [ngModel]="draft().overrideIsActive"
                        (ngModelChange)="setField('overrideIsActive', $event)"
                    />
                    <label for="cfg-ovr-active" class="font-medium">Override active</label>
                </div>
                @if (draft().overrideIsActive) {
                    <div class="flex items-center gap-2 pl-6">
                        <p-checkbox
                            inputId="cfg-active-val"
                            [binary]="true"
                            [ngModel]="draft().isActive"
                            (ngModelChange)="setField('isActive', $event)"
                        />
                        <label for="cfg-active-val" class="text-sm">{{ draft().isActive ? 'Active' : 'Inactive' }}</label>
                    </div>
                } @else {
                    <div class="text-xs text-muted-color pl-6">
                        Inherits from template: {{ t.IsActive ? 'Active' : 'Inactive' }}
                    </div>
                }
            </div>

            @if (saveError()) {
                <p-message severity="error" [text]="saveError()!" />
            }
        </div>
    }

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" outlined [disabled]="saving()" (onClick)="close()" />
            <p-button
                label="Add"
                icon="pi pi-check"
                [loading]="saving()"
                [disabled]="!canSave()"
                (onClick)="save()"
            />
        </div>
    </ng-template>
</p-dialog>
